import { render, staticRenderFns } from "./data-percent-averages.vue?vue&type=template&id=475b3f27&scoped=true&"
import script from "./data-percent-averages.vue?vue&type=script&lang=js&"
export * from "./data-percent-averages.vue?vue&type=script&lang=js&"
import style0 from "./data-percent-averages.vue?vue&type=style&index=0&id=475b3f27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b3f27",
  null
  
)

component.options.__file = "data-percent-averages.vue"
export default component.exports